import { useEffect, useState } from 'react';
import { documentProgress } from './api';

/**
 * Asks the server where each still-unresolved upload is (queued, reading, failed, gone) while any are.
 * An upload is resolved once its invoice shows up in the lists, so nothing is polled for settled rows.
 * Keeps the last answer when a poll fails, and does nothing while the tab is hidden.
 */
export default function useUploadProgress(uploads, invoicesByDoc, intervalMs = 3000) {
  const [progress, setProgress] = useState({});
  const pending = uploads
    .filter((u) => u.documentId && !u.error && !u.duplicate && !invoicesByDoc[u.documentId])
    .map((u) => u.documentId);
  const key = pending.join(',');

  useEffect(() => {
    if (!key) return undefined;
    let alive = true;
    const load = async () => {
      try {
        const data = await documentProgress(key.split(','));
        if (alive) setProgress((prev) => ({ ...prev, ...((data && data.items) || {}) }));
      } catch { /* keep the last answer */ }
    };
    load();
    const timer = setInterval(() => {
      if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
      load();
    }, intervalMs);
    return () => { alive = false; clearInterval(timer); };
  }, [key, intervalMs]);

  return progress;
}
